import { Reveal } from "@/components/Reveal";
import { SYSTEM_STEPS, STATS } from "@/data";

export const ProvenSystem = () => {
  return (
    <section id="system" data-testid="system-section" className="bg-[#FAFAFA] border-y border-neutral-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-14">
          <Reveal className="lg:col-span-8">
            <p className="overline text-kw-red mb-4">The Proven System</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-kw-ink leading-[1.02]">
              A strategy designed to make buyers compete for your home.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4">
            <p className="text-neutral-600 leading-relaxed">
              No guesswork. No months of uncertainty. Just a clear, three-part plan engineered to
              maximize your price and minimize your stress.
            </p>
          </Reveal>
        </div>

        {/* Tetris grid */}
        <div className="grid lg:grid-cols-12 gap-0 border border-neutral-200 bg-white">
          {SYSTEM_STEPS.map((s, i) => (
            <Reveal
              key={s.n}
              delay={i * 0.12}
              className={`lg:col-span-4 p-8 sm:p-10 ${i < 2 ? "lg:border-r" : ""} border-b lg:border-b-0 border-neutral-200`}
            >
              <span className="font-serif text-6xl sm:text-7xl text-kw-red leading-none">{s.n}</span>
              <h3 className="mt-5 font-serif text-2xl sm:text-3xl tracking-tight text-kw-ink">{s.title}</h3>
              <p className="mt-3 text-sm sm:text-base text-neutral-600 leading-relaxed">{s.text}</p>
            </Reveal>
          ))}
        </div>

        {/* Stats */}
        <div className="grid sm:grid-cols-3 gap-0 mt-0 border-x border-b border-neutral-200 bg-white">
          {STATS.map((st, i) => (
            <Reveal
              key={st.label}
              delay={i * 0.1}
              className={`p-8 ${i < 2 ? "sm:border-r" : ""} border-b sm:border-b-0 border-neutral-200`}
            >
              <p className="font-serif text-4xl text-kw-ink">{st.value}</p>
              <p className="mt-2 text-sm text-neutral-500">{st.label}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
